/* ===== Картинки Команды ===== */
import olga from "../assets/images/olga.png";
import nastya from "../assets/images/anastasiya.png";
import nikita from "../assets/images/nikita.png";
import dima from "../assets/images/dima.png";


const comands = {
  id: "team",
  grid: { cols: { base: 1, sm: 2, lg: 4 }, gap: "var(--spacing-4)" },
  items: [
    {
      id: "team-1",
      type: "team",
      photo: olga,
      name: "Фишер Ольга",
      position: "Генеральный Директор",
    },
    {
      id: "team-2",
      type: "team",
      photo: nastya,
      name: "Иванова Анастасия",
      position: "Отдел логистики",
    },
    {
      id: "team-3",
      type: "team",
      photo: nikita,
      name: "Кузьминов Никита",
      position: "Коммерческий отдел",
    },
    {
      id: "team-4",
      type: "team",
      photo: dima,
      name: "Шептухин Дмитрий",
      position: "Отдел продаж",
      imgSize: "small",
    },
  ],
};


export default comands;

